import React, { useState, useEffect } from 'react';
import {object, func, bool} from 'prop-types';
import {CloneObject, GetListaSubTasaValores} from '../../../utils/helpers';
import { useFormErrors } from '../../hooks/useFormErrors';
import { isNull } from '../../../utils/validator';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useForm } from '@laramie/ui';
import { InputTasa, InputSubTasa, DatePickerCustom, Accordion, FormLabel, Modal, Select, FormError } from '../../common';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {TIPS} from "../../../consts/tips";


const SubTasaValorModal = (props) => {

    const entityInit = {
        id: 0,
        idTasa: 0,
        idSubTasa: 0,
        fechaDesde: null,
        fechaHasta: null,
        codigo: '',
        valor: ''
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            idTasa: props.data.entity.idTasa,
            idSubTasa: props.data.entity.idSubTasa,
            fechaDesde: props.data.entity.fechaDesde,
            fechaHasta: props.data.entity.fechaHasta,
            codigo: props.data.entity.codigo,
            valor: props.data.entity.valor
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTasa: 0,
        idSubTasa: 0,
        fechaDesde: null,
        fechaHasta: null,
        codigo: '',
        valor: ''
    });

    const [valorOpen, setValorOpen] = useState(true);

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //handles
    const handleClickAceptar = () => {
        if (Object.keys({...getErrors(), ...getFormatErrors()}).length > 0) setValorOpen(true);

        if (validate()) {

            let row = CloneObject(state.entity);
            row.fechaDesde = formValues.fechaDesde;
            row.fechaHasta = formValues.fechaHasta;
            row.codigo = formValues.codigo;
            row.valor = formValues.valor;

            setValorOpen(true);
            props.onConfirm(row);
        }
        ;
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.codigo.length <= 0) errors.codigo = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.valor.toString().length <= 0) errors.valor = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }

    function getFormatErrors() {

        const errors = {};
        if (props.disabled) return errors;

        if (formValues.valor.toString().length > 0 && formValues.valor <= 0) errors.valor = 'Ingresá un número mayor a cero';
        if (esRangoSolapado()) errors.fechaDesde = 'El rango se superpone con otro';

        return errors;
    }

    function esRangoSolapado() {
        const rango = props.rangoSolapado;
        return !isNull(rango)
            && rango.codigo === formValues.codigo
            && sonLaMismaFecha(rango.fechaDesde, formValues.fechaDesde)
            && sonLaMismaFecha(rango.fechaHasta, formValues.fechaHasta);
    }

    function sonLaMismaFecha(una, otra) {
        if (isNull(una) || isNull(otra)) return isNull(una) && isNull(otra);
        return una.getTime() === otra.getTime();
    }

    return (
        <>

            <Modal
                size="lg"
                title="Valor"
                tipName={TIPS.NAME.MODALS.VALOR_SUB_TASA_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row form-basic">

                                <div className="mb-3 col-12">
                                    <Accordion title="Valor" open={valorOpen} onToggle={setValorOpen}>
                                        <div className='row form-basic'>
                                            <div className="col-12 col-md-6">
                                                <label htmlFor="idTasa" className="form-label">Tasa</label>
                                                <InputTasa
                                                    name="idTasa"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idTasa}
                                                    disabled={true}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label htmlFor="idSubTasa" className="form-label">Sub tasa</label>
                                                <InputSubTasa
                                                    name="idSubTasa"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idSubTasa}
                                                    disabled={true}
                                                    idTasa={formValues.idTasa}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="fechaDesde" className="form-label">Fecha
                                                    desde</label>
                                                <DatePickerCustom
                                                    name="fechaDesde"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaDesde}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaDesde')} />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="fechaHasta" className="form-label">Fecha
                                                    hasta</label>
                                                <DatePickerCustom
                                                    name="fechaHasta"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaHasta}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    minValue={formValues.fechaDesde}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <FormLabel htmlFor="codigo" required>Código</FormLabel>
                                                <Select
                                                    name="codigo"
                                                    className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                                                    value={formValues.codigo}
                                                    onChange={({target}) => {
                                                        formSet({
                                                            ...formValues,
                                                            codigo: target.value
                                                        });
                                                    }}
                                                    disabled={props.disabled}
                                                    options={GetListaSubTasaValores().map(item => ({ value: item.key, label: item.value }))}
                                                />
                                                <FormError message={errorOf('codigo')} />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <FormLabel htmlFor="valor" required>Valor</FormLabel>
                                                <input
                                                    name="valor"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('valor') ? 'is-invalid' : ''}`}
                                                    value={formValues.valor}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('valor')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de valores"
                                            processKey={props.processKey}
                                            entidad="SubTasaValor"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

SubTasaValorModal.propTypes = {
    disabled: bool,
    data: object.isRequired,
    rangoSolapado: object,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

SubTasaValorModal.defaultProps = {
    disabled: false,
    rangoSolapado: null
};

export default SubTasaValorModal;